
export const useTogglePasswordVisibility = () => {
  const passwordFieldType = ref('password');
  const togglePasswordVisibility = () => {
    passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password';
  };
  const passwordToggleIcon = computed(() => passwordFieldType.value === "password" ? "fa-eye" : "fa-eye-slash");

  return {
    passwordFieldType,
    togglePasswordVisibility,
    passwordToggleIcon,
  };
} 

export const _ = null;
